export const pieChartColors = {
  blue: "#5B79B4",
  red: "#FB787A",
  green: "#63A5A1",
  orange: "#F4A261",
  dark_blue: "#5B79B4",
  light_blue: "#6ACFEF",
  gray: "#C8C8C8"
}